/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	line: {
		height: '1px',
		width: '100%',
		backgroundColor: token('color.background.accent.gray.subtle'),
	},
});

export const SeparatorLine: () => JSX.Element = () => <Box xcss={styles.line} />;
